<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('productGroup.printer') }}</label>
        <input
          v-model="model.printer_kot"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('printer_kot') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('printer_kot')"
        >{{ errors.first('printer_kot') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('productGroup.ipAddress') }}</label>
        <input
          v-model="model.printer_ip_address"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('printer_ip_address') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('printer_ip_address')"
        >{{ errors.first('printer_ip_address') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('productGroup.port') }}</label>
        <input
          v-model.number="model.port"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('port') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('port')"
        >{{ errors.first('port') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('productGroup.type') }}</label>
        <select
          class="form-control"
          v-model="model.input_type"
          :class="{ 'is-invalid': errors.has('input_type') }"
        >
          <option value="USB">USB</option>
          <option value="NETWORK">NETWORK</option>
        </select>
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('input_type')"
        >{{ errors.first('input_type') }}</div>
      </div>
    </div>
		<div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <!-- <ts-button
					class="mr-2"
          color="primary"
					outline
          @click.prevent="onSaveAddNew"
          :waiting="waiting_new"
        >{{ $t('save_add_new') }}</ts-button> -->
        <ts-button
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'addPrinter',
  props: ['value'],
  data() {
    return {
			errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {}
    }
  },
  created() {
		this.model = this.value
		// this.clearInput()
	},
	methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('product/group/addPrinter', this.model)
        .then(response => {
					this.$toasted.success(response.message)
					this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.$store
        .dispatch('product/group/addPrinter', this.model)
        .then(response => {
					this.$toasted.success(response.message)
					this.clearInput()
					this.$emit('fetchData')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
		},
		clearInput(){
			this.model.printer_kot = null
      this.model.printer_ip_address = null
      this.model.port = null
      this.model.input_type = 'NETWORK'
		}
  }
}
</script>